import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getPanelUsers, getPanelUsersTopluExcel } from "../../features/admin3/admin3Slice"
import { useSelector } from "react-redux"
import Pagination from "../../components/shared/Pagination"
import PanelUyelerTable from "../../components/shared/adminUyelerAraclar/PanelUyelerTable"
import Btn from "../../components/shared/button/Btn"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import InputSelect from "../../components/shared/input/new/InputSelect"

const Container = styled.div`
    .wrapper {
        width: 100%;
        padding: 30px;

        .top-container {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            gap: 30px;
            margin-bottom: 30px;
        }
    }
`

const initialOptions = [
    {
        value: "",
        text: "Hepsi"
    },
    {
        value: 1,
        text: "Nakliyeci"
    },
    {
        value: 2,
        text: "Kooperatif"
    }
]

const AdminPanelUsers = () => {

    const dispatch = useDispatch()
    const {isLoadingPanelUsers, panelUsers, panelUsersCount, isLoadingGetPanelUsersTopluExcel} = useSelector(state => state.admin3)
    const itemsPerPage = 10;
    const totalPages = Math.ceil(panelUsersCount / itemsPerPage);

    const [currentPage, setCurrentPage] = useState(1)
    const [firmaType, setFirmaType] = useState({
        value:"",
        text: "Hepsi"
    })

    useEffect(() => {
        dispatch(getPanelUsers({
            currentPage,
            firmaType: firmaType.value
        }))
    },[currentPage, firmaType])

    useEffect(() => {
        setCurrentPage(1)
    },[firmaType])


  return (
    <Container>
            <PageTopTitle title={"Panel Üyeler"}/>
        <div className="wrapper">
            <div className="top-container">
                <InputSelect initialOptions={initialOptions} data={firmaType.text} setData={setFirmaType} labelText={"Firma Türü"}/>
                <Btn bgColor="#E85446" color="#fff" width={"220px"} handleClick={() => dispatch(getPanelUsersTopluExcel())}>{isLoadingGetPanelUsersTopluExcel ?   <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn>
            </div>
            <div className="content">
                <PanelUyelerTable list={panelUsers}/>
                <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
            </div>
        </div>
    </Container>
  )
}

export default AdminPanelUsers